module.exports = __webpack_public_path__ + "img/atencion.55ef5797.png";